import VideaBrandSm from '../../common-components/elements/icon/svgs/VideaBrandSm';
import { blueBlack400 } from '../../theme/videa-style-tokens';
import { useAppContext } from '../../utils/hooks/useAppContext';

export const RenderLogo = ({ color }: { color?: string }) => {
  const { isAuthenticated } = useAppContext();
  return isAuthenticated ? (
    <div className="logo vai-overflow-hidden">
      <VideaBrandSm color={color ?? blueBlack400} />
    </div>
  ) : (
    <></>
  );
};
